import _ from 'lodash'
import Vue from 'vue'

export default {
    initDefaultFields(state, key) {
        Vue.set(state, key, {
            // formType: null,
            // segmentType: null,
            // otpStatus: null,
            idenfoId: null,
            dataSegmentId: null,
            dataSegmentType: null,
            recieveOtpOption: [],
            relativeInfo: {
                relation: null,
                relativesCnic: null,
            },
            basicInfo: {
                salutation: null,
                firstName: null,
                middleName: '',
                lastName: '',
                genderId: null,
                gender: '',
                dateOfBirth: null,
                nationalityId: null,
                nationality: null,
                countryOfResidenceId: null,
                countryOfResidence: null,
                //
                fatherOrHusbandName: null,
                fatherName: null,
                motherName: null,
                placeOfBirth: null,
                religion: null,
                zakat: [],
                ntn: null,
                taxStatus: null,
                otherNationalities: null,
                // hasOtherNationalities: null,
                residentialStatus: null,
                permPakResident: null,
                kycNationality: null,
                hasOtherNationalities: null,
                residentialStatus: null,
                otherPermanentCity: null,
                permanentProvince: null,
                otherPermanentProvince: null,
                permanentAddress: null,
                permanentCity: null,
                permanentCountry: null,
                permanentOfficeNumber: null,
                permanentResNumber: null,
                relationship: null,
                maritalStatus: 'S',
                fatherHusbandName: null,
                fax: null,
                permanentFax: null,
                province: null,
                otherProvince: null,
            },
            identityInfo: {
                type: 'id',
                idDocumentType: null,
                number: null,
                expiryDate: null,
                //
                IssuanceDate: null,
                isLifetimeExpiry: null,
                uinExpiryOption: null,
                issueDate: null,
            },
            occupationInfo: {
                workTypeId: null,
                workType: null,
                industryId: null,
                industry: null,
                taxId: null,
                //
                // taxNo: null,
                education: null,
                occupation: null,
                taxNo: null,
                sourceOfFunds: null,
                businessNature: null,
                geographies: null,
                geographiesOther: null,
                counterParties: null,
                counterPartiesOthers: null,
                occupation: null,
            },
            contactInfo: {
                address: null,
                stateId: null,
                state: '',
                city: null,
                postalCode: null,
                isdCode: null,
                phoneNumber: null,
                email: null,
                //
                greenCardUS: null,
                residentUS: null,
                businessAddress: null,
                phoneRes: null,
                phoneOffice: null,
                fax: null,
                phoneWhatsApp: null,
            },
            accountInfo: {
                purposeOfActionId: null,
                purposeOfAction: '',
                products: [],
                expectedCredit: null,
                creditLimit: null,
                grossIncome: null,
                initialBalance: null,
                //
                guardianName: null,
                guardianRelationship: null,
                guardianCNIC: null,
                guardianIssuanceDate: null,
                guardianExpiryDate: null,
                receiveAccountStatement: null,
                mailNature: null,
                mailNatureMisc: null,
                nomineeName1: null,
                nomineeRelationship1: null,
                nomineeCNIC1: null,
                nomineeIssuanceDate1: null,
                nomineeExpiryDate1: null,
                nomineeAllocation1: null,
                nomineeName2: null,
                nomineeRelationship2: null,
                nomineeCNIC2: null,
                nomineeIssuanceDate2: null,
                nomineeExpiryDate2: null,
                nomineeAllocation2: null,
                jointAHName: null,
                jointAHFatherOrHusbandName: null,
                jointAHCNIC: null,
                jointAHHoldingPerc: null,
                bankTitle: null,
                bankName: null,
                bankAccNo: null,
                bankAccountNo: null,
                bankBranch: null,
                bankBranchCode: null,
                bankAddress: null,
                bankIBAN: null,
                operateAccount: null,
                operateAccountOther: null,
                cashDividend: null,
                stockDividend: null,
                hearUs: null,
                natureBusinessRelation: null,
                deliveryChannels: null,
                expectedTransactions: null,
                expectedTurnover: null,
                declarationCustomer1: null,
                declarationCustomer2: null,
                declarationCustomer3: null,
                declarationCustomer4: null,
                ultimateBenName: null,
                ultimateBenRelation: null,
                ultimateBenIdNo: null,
                otherCity: null,
            },
            accountInfo: {
                purposeOfActionId: '6034ac8faf49df61fca9b6ef',
                products: [
                    {
                        _id: '60117375be8a6353dc5c986c',
                        productId: '5d43ce7fe65aaf226381610f',
                        title: 'Current Account',
                    },
                ],
                expectedCredit: '100000',
                creditLimit: '100000',
                grossIncome: '100000',
                initialBalance: '100000',
                internationalBankAccountNumberIban: null,
                jobTitle: null,
                department: null,
                nameOfEmployer: null,
                employerAddress: null,
                zakatStatus: null,
                relativeName: null,
                bankName: null,
                accountType: null,
                annualIncome: null,
            },
            attorneyInfo: {
                salutation: null,
                uniqueIdentificationNumber: null,
                firstName: null,
                lastName: null,
                identificationType: null,
                uinExpiry: null,
                uinExpiryOption: null,
                attorneyMobile: null,
                emailAddress: null,
                mailingAddress: null,
                mailingProvince: null,
                otherProvince: null,
                mailingCity: null,
                otherCity: null,
                landline: null,
                fax: null,
                country: null,
            },
            nomineeInfo: {
                nomineeName: null,
                IdentificationType: null,
                relationshipWithNominee: null,
                uniqueIdentificationNumber: null,
                uinExpiryOption: null,
                uinExpiry: null,
            },
            documentInfo: {
                digitalSignature: {
                    fileName: null,
                    originalFileName: null,
                },
                cnicBack: {
                    fileName: null,
                    originalFileName: null,
                },
                utility: {
                    fileName: 'id.jpg',
                    originalFileName: 'file-1610374528421.jpg',
                },
                iban: {
                    fileName: null,
                    originalFileName: null,
                },
                relative: {
                    fileName: null,
                    originalFileName: null,
                },
                identity: {
                    originalFileName: 'bill.jpg',
                    fileName: 'file-1610374528421.jpg',
                },
                cnicFront: {
                    originalFileName: null,
                    fileName: null,
                },
                cnicBack: {
                    originalFileName: null,
                    fileName: null,
                },
                employerAddress: {
                    fileName: null,
                    originalFileName: null,
                },
                address: {
                    fileName: null,
                    originalFileName: null,
                },

                zakatDeclaration: {
                    fileName: null,
                    originalFileName: null,
                },

                video: {
                    fileName: 'file-1610374572784.mp4',
                    originalFileName: null,
                },
            },
            customInfo: {},
            investmentProduct: {
                disclaimer: false,
                score: null,
                tolerance: null,
                selectOptions: [],
                selectedProducts: [],
                selectedProductsNames: [],
                recommendedRisk: {
                    title: null,
                },
            },
            crsInfo: {
                crsCountryTax1: null,
                crsTIN1: null,
                crsReason1: null,
                crsOtherReason1: null,
                crsCountryTax2: null,
                crsTIN2: null,
                crsReason2: null,
                crsOtherReason2: null,
                crsCountryTax3: null,
                crsTIN3: null,
                crsReason3: null,
                crsOtherReason3: null,
            },
            forms: {
                form1: {
                    valid: false,
                    routeName: 'identity-document',
                    name: 'Identity Document',
                },
                form2: {
                    valid: false,
                    routeName: 'setup-profile',
                    name: 'Setup Profile',
                },
                form3: {
                    valid: false,
                    routeName: 'account-info',
                    name: 'Account Info',
                },
                form4: {
                    valid: false,
                    routeName: 'kyc',
                    name: 'KYC',
                },
                form5: {
                    valid: false,
                    routeName: 'investment',
                    name: 'Investment',
                },
                form6: {
                    valid: false,
                    routeName: 'risk-product',
                    name: 'Risk Product',
                },

                form7: {
                    valid: false,
                    routeName: 'upload-document',
                    name: 'Upload Document',
                },
            },
        })
        state.isIndustrial = true
        state.isTaxIdRequired = false
    },
    initCustomField(state, { key, value }) {
        Vue.set(state.form.customInfo, key, value)
    },
    updateField(state, payload) {
        _.set(state.form, payload.key, payload.value)
    },
    setValue(state, { key, value }) {
        state[key] = value
    },
}
